var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon16/arrow/move",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49189583,9.18859497 L8.49189583,14.2626422 L10.4682593,12.2862788 L11.1753661,12.9933855 L7.99338555,16.1753661 L4.81140503,12.9933855 L5.51851181,12.2862788 L7.49487527,14.2626422 L7.49487527,9.18859497 L8.49189583,9.18859497 Z M12.8047906,5 L15.9867711,8.18198052 L12.8047906,11.363961 L12.0976838,10.6568542 L14.0740473,8.6804908 L9,8.6804908 L9,7.68347023 L14.0740473,7.68347023 L12.0976838,5.70710678 L12.8047906,5 Z M3.18198052,5 L3.8890873,5.70710678 L1.91272384,7.68347023 L6.98677109,7.68347023 L6.98677109,8.6804908 L1.91272384,8.6804908 L3.8890873,10.6568542 L3.18198052,11.363961 L-6.75903777e-13,8.18198052 L3.18198052,5 Z M7.99338555,0.188594969 L11.1753661,3.37057548 L10.4682593,4.07768227 L8.49189583,2.10131881 L8.49189583,7.17536606 L7.49487527,7.17536606 L7.49487527,2.10131881 L5.51851181,4.07768227 L4.81140503,3.37057548 L7.99338555,0.188594969 Z",
    id: "Shape",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.331e90ea11d013d3196ed06d30ea27e9.svg";
export { ForwardRef as ReactComponent };